import React from 'react';
import PropTypes from 'prop-types';
import externalLinkGreyIcon from 'assets/images/icons/link-external-grey.svg';
import infoCircleGreyIcon from 'assets/images/icons/info-circle.svg';
import { CallAPI } from 'actions/General';
import { FONT_FAMILY_MAP } from '../utils';
import InfoTooltip from 'components/common-components/InfoTooltip';

const TextChartComponent = ({ widget, editMode }) => {
  const { basicProps, advancedProps } = widget;

  const captionFontFamily = FONT_FAMILY_MAP[advancedProps.captionFontWeight] || '';

  const getPageDetails = async (pageId) => {
    const result = await CallAPI('GET_DASHBOARD_PAGE_DETAIL', null, pageId);
    if (result.status) {
      window.open(`/dashboards/navigate/${result.data.dashboardId}/${pageId}`, '_blank');
    }
  };

  return (
    <div className='d-flex flex-column gap-3 align-items-center p-3'>
      {!editMode && (
        <div className='d-flex align-items-center gap-2'>
          {basicProps.caption && (
            <span
              style={{
                fontSize: advancedProps.captionFontSize,
                fontFamily: captionFontFamily,
              }}
            >
              {basicProps.caption}
            </span>
          )}
          {advancedProps.tooltip && (
            <InfoTooltip
              text={advancedProps.tooltip}
              triggerElement={<img src={infoCircleGreyIcon} />}
            />
          )}
        </div>
      )}
      <div className='w-100 d-flex flex-column gap-2 justify-content-center align-items-center'>
        {basicProps.textLinks.map((textLink, index) => (
          <div
            key={index}
            className='w-100 d-flex justify-content-between border-grey-13-h-1 rounded-sm p-2'
          >
            <label>{textLink.text}</label>
            {textLink.linkedPageId && (
              <img
                className='cursor-pointer'
                src={externalLinkGreyIcon}
                onClick={() => {
                  if (!editMode) getPageDetails(textLink.linkedPageId);
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

TextChartComponent.propTypes = {
  widget: PropTypes.object.isRequired,
  editMode: PropTypes.bool,
};

export default TextChartComponent;
